export const DEFAULT_LOCALE = "zh-CN";
export const ENGLISH_LOCALE = "en-US";
export const LOCALES_STORE_KEY = "lang";

export const LANG_MAP = {
    [ENGLISH_LOCALE]: 'ENGLISH',
    [DEFAULT_LOCALE]: '中文简体'
}

// locale data
export const locales = {
    [ENGLISH_LOCALE]: require('./en-US.json'),
    [DEFAULT_LOCALE]: require('./zh-CN.json'),
};


export const LOCALES_HELPER = {
    getLan(){
        return localStorage.getItem(LOCALES_STORE_KEY) || DEFAULT_LOCALE
    },
    setLan(lang){
        localStorage.setItem(LOCALES_STORE_KEY, lang)
    }
}
